import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface TranslateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  fieldLabel: string;
  spanishValue: string;
  englishValue: string;
  onSave: (englishValue: string) => void;
  multiline?: boolean;
}

export function TranslateDialog({
  open,
  onOpenChange,
  fieldLabel,
  spanishValue,
  englishValue,
  onSave,
  multiline = false,
}: TranslateDialogProps) {
  const [value, setValue] = useState(englishValue);

  useEffect(() => {
    setValue(englishValue);
  }, [englishValue, open]);

  const handleSave = () => {
    onSave(value);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Traducir {fieldLabel.toLowerCase()}</DialogTitle>
          <DialogDescription>
            Añade la traducción al inglés para este campo
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="space-y-1.5">
            <label className="text-xs font-medium text-gray-500 flex items-center gap-1.5">
              <span>🇪🇸</span> Español
            </label>
            {multiline ? (
              <textarea
                value={spanishValue}
                readOnly
                className="w-full min-h-[80px] px-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded-md resize-none"
              />
            ) : (
              <Input
                value={spanishValue}
                readOnly
                className="bg-gray-50 border-gray-200"
              />
            )}
          </div>
          
          <div className="space-y-1.5">
            <label className="text-xs font-medium text-gray-500 flex items-center gap-1.5">
              <span>🇬🇧</span> English
            </label>
            {multiline ? (
              <textarea
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="English translation..."
                className="w-full min-h-[80px] px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-primary resize-none"
              />
            ) : (
              <Input
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="English translation..."
              />
            )}
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={handleSave}>
            Guardar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
